import React from 'react';
import { CLASSNAME } from '@skin-seoul/service';
import giftIcon from './assets/gift.png';
import shieldIcon from './assets/shield.png';
import packageIcon from './assets/package.png';
import { resolveImageSrc } from '../../../utils';

/** Kept on its own row: it is the headline benefit, and it is too wide to share one with the others. */
const FREE_SAMPLE_BADGE = { label: 'Free Samples with this order', icon: giftIcon };

const SUPPORTING_BADGES = [
  { label: 'Authenticity Guarantee', icon: shieldIcon },
  { label: 'Easy Returns', icon: packageIcon },
];

interface TrustBadgeProps {
  label: string;
  icon: { src: string } | string;
}

const TrustBadge = ({ label, icon }: TrustBadgeProps) => (
  <div className="flex items-center gap-2 bg-primary-50 rounded-[36px] pl-3 pr-4 py-1">
    {/* Decorative: the label beside it already names the badge for screen readers. */}
    <img src={resolveImageSrc(icon)} alt="" className="w-6 h-6 shrink-0" />
    <span className={`text-label-small font-medium text-neutral-800 ${CLASSNAME.NOT_TRANSLATE}`}>{label}</span>
  </div>
);

export function CartTrustBadges() {
  return (
    <div className="flex flex-col gap-2 items-center w-full py-2">
      <TrustBadge {...FREE_SAMPLE_BADGE} />
      <div className="flex gap-2 items-center justify-center flex-wrap">
        {SUPPORTING_BADGES.map((badge) => (
          <TrustBadge key={badge.label} {...badge} />
        ))}
      </div>
    </div>
  );
}
